//-------------------------------------------------------------------------------------------
//
//  Methods to convert between azimuth (compass bearing) angles and other measures
//

/**
 * convert azimuth to reference angle in degrees
 *
 * @param azimuth bearing in degrees, increasing clockwise from due north
 * @return degrees, increasing counter-clockwise from +X axis
 */
// export function azimuthToDegrees(azimuth: number) {
//   let theta = 450.0 - azimuth;
//   if (theta >= 360.0) theta -= 360.0;
//   return theta;
// }

/**
 * convert an azimuth angle to standard trig angle
 * @param azimuth bearing in degrees, increasing clockwise from due north
 * @return radians, increasing counter-clockwise from +X axis
 */
// function azimuthToRadians(azimuth:number) {
//     return Math.toRadians(azimuthToDegrees(azimuth));
// }

/**
 * convert an angle in standard radians to azimuth bearing
 * @param angleRadians radians, increasing CCW from +X axis
 * @return bearing in degrees, increasing clockwise from due north
 */
export function radiansToAzimuth(angleRadians: number) {
  let az = (180.0 / Math.PI) * (Math.PI / 2.0 - angleRadians);
  if (az < 0.0) {
    az += 360.0;
  }
  return az;
}
/**
 * convert an angle in degrees to radians
 * @param angleDegrees
 * @returns
 */
export function degreesToRadians(angleDegrees: number) {
  const rad = (angleDegrees * Math.PI) / 180;
  return rad;
}

/**
 * Function to replace parseFloat(number.toFixed(n)) while avoiding errors with toFixed().
 * Meant for cases like numerical inputs where the input could be erased and no longer a proper number.
 *
 * @param value the target number to round
 * @param maxDecimals maximum decimal places allowed
 * @returns A Number rounded to a certain decimal precision
 */
export function toDecimalPrecision(value: number, maxDecimals: number): number {
  // If not undefined or null, could still be "".
  // Cant check if typed as a number, but will still happen.
  // +"" should evaluate this as a number since parse float doesn't work on numbers.
  const temp = +value;
  return parseFloat(temp.toFixed(maxDecimals));
}
/**
 * convert an angle in radians to degrees
 * @param angleRadians
 * @returns
 */
export function radiansToDegrees(angleRadians: number) {
  const degrees = angleRadians * (180 / Math.PI);
  return degrees;
}
/**
 * 
 * @param azimuth 
 * @returns 
 */
export function azimuthToDegrees(azimuth: number) {
  let theta = 450.0 - azimuth;
  if (theta >= 360.0)
    theta -= 360.0;
  return theta;
}
/**
 * 
 * @param azimuth 
 * @returns 
 */
export function azimuthToRadians(azimuth: number) {
  return degreesToRadians(azimuthToDegrees(azimuth));
}

export function feetToMeters(feet: number) {
  return feet * 0.3048;
}

/**
 * 
 * @param value 
 * @returns 
 */
export function convertStringFractionToDecimal(value: string) {
  return value.includes('/') ? parseFloat(value.split('/')[0]) / parseFloat(value.split('/')[1]) : parseFloat(value)
}

/**
 * Rounds a number to a given number of decimal points by multiplying by 10^decimal and rounding to the nearest integer. Returns a rounded value of type string.
 * Note: This function can have precision errors at unexpected values. See storybook "Halfway Rounding" and this functions unit tests for examples.
 * @param value 
 * @param maxDecimals 
 * @returns 
 */
export function epsilonShiftRoundS(value: number, maxDecimals: number): string {
  return (Math.round((value + Number.EPSILON) * Math.pow(10, maxDecimals)) / Math.pow(10, maxDecimals)).toString();
}
/**
 * Rounds a number to a given number of decimal points by multiplying by 10^decimal and rounding to the nearest integer. Returns a rounded value of type number.
 * Note: This function can have precision errors at unexpected values. See storybook "Halfway Rounding" and this functions unit tests for examples.
 * @param value 
 * @param maxDecimals 
 * @returns 
 */
export function epsilonShiftRound(value: number, maxDecimals: number): number {
  return (Math.round((value + Number.EPSILON) * Math.pow(10, maxDecimals)) / Math.pow(10, maxDecimals));
}

/**
 * Round a number to a specified decimal precision using Intl.NumberFormat. Returns rounded value as type {number}.
 * @param value 
 * @param maxDecimals 
 * @returns 
 */
export function formatRound(value: number, maxDecimals: number): number {
  return parseFloat(Intl.NumberFormat('en-US', {
    minimumFractionDigits: maxDecimals,
    maximumFractionDigits: maxDecimals,
    useGrouping: false
  }).format(value));
}
/**
 * Round a number to a specified decimal precision using Intl.NumberFormat. Returns rounded value as type string.
 * @param value 
 * @param maxDecimals 
 * @returns 
 */
export function formatRoundS(value: number, maxDecimals: number): string {
  return Intl.NumberFormat('en-US', {
    minimumFractionDigits: maxDecimals,
    maximumFractionDigits: maxDecimals,
    useGrouping: false
  }).format(value);
}
export function formatRoundSTrim(value, maxDecimals: number): string | undefined {
  if (isNaN(value)) {
    return undefined;
  } else {
    return Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: maxDecimals,
      useGrouping: false
    }).format(value)
  }
}
export function updateToTenChars(number) {
  let numStr = Number(number).toString();

  let [integerPart, fractionalPart = ''] = numStr.split('.');
  if (!numStr.includes('.')) {
    numStr = integerPart + '.';
    fractionalPart = '';
  }
  // Calculate how many digits we need after the decimal
  const totalLength = integerPart.length + 1 + fractionalPart.length;
  const digitsAfterDecimal = 10 - integerPart.length - 1;

  if (totalLength < 10) {
    // Pad with zeros after the decimal
    fractionalPart = fractionalPart.padEnd(digitsAfterDecimal, '0');
  } else if (totalLength > 10) {
    // Truncate fractional part to fit 10 characters
    fractionalPart = fractionalPart.slice(0, digitsAfterDecimal);
  }
  // Combine and return 10 characters
  return `${integerPart}.${fractionalPart}`;
}